export const classes = (...classNames: any[]) =>
  classNames.filter(Boolean).join(' ');
